import React from 'react';

const WardDrive = () => {
  return <div />;
};

export default WardDrive;
